import React, { Component } from 'react';
import compose from 'lodash.flowright';

import SelfieCaptureContainer from '../../components/global/selfie-capture/SelfieCapture';
import getLogger from '../../util/logger';

const logger = getLogger('SelfieCaptureView');

class SelfieCaptureView extends Component {
  onSelfieConfirmed = file => logger.info(`onSelfieConfirmed :: file:`, file);

  onError = error => logger.error(`onError :: error: `, error);

  render() {
    return (
      <SelfieCaptureContainer
        onSelfieConfirmed={this.onSelfieConfirmed}
        onError={this.onError}
        onClose={() => logger.info('Closed')}
        countdown={3}
      />
    );
  }
}
export default compose()(SelfieCaptureView);
